import { Col, Container, Row } from "react-bootstrap";
import calendar from '../../assets/images/calendar.svg';
import user from '../../assets/images/user.svg';
import languages from '../../assets/images/languages.svg';
import clock from '../../assets/images/clock.svg';

const OurServices = () => {


  return (

    <Container >
      {/* className="my-md-5 pt-5" */}

      <div className="text-center">
        <h1 className="courses-title mb-md-4 mb-3">Why One Stop Solution ?</h1>
        <p className="course-syllabus-desc pb-md-5 pb-3">Four different vendors = endless problems. One integrated studio = no problems at all.</p>
      </div>

      <Row>
        <Col md={6}>
          <div className="course-card wrong">
            <div className="course-badge">
              <span className="fa-solid fa-xmark" />
            </div>
            <h2 className="course-card-title  font-weight-bold">Most Homeowners Face</h2>
            <p className="course-list">
              <span className="fa-solid fa-people-arrows" />
              <span className="ms-md-3">Architect vs contractor conflicts</span>
            </p>
            <p className="course-list">
              <span className="fa-solid fa-clock-rotate-left" />
              <span className="ms-md-3">Approval delays</span>
            </p>
            <p className="course-list">
              <span className="fa-solid fa-drafting-compass" />
              <span className="ms-md-3">Wrong drawings at site</span>
            </p>
            <p className="course-list">
              <span className="fa-solid fa-couch" />
              <span className="ms-md-3">Poor interiors after construction</span>
            </p>
            <p className="course-list">
              <span className="fa-solid fa-handshake-slash" />
              <span className="ms-md-3">Fake promises</span>
            </p>
            <p className="course-list">
              <span className="fa-solid fa-project-diagram" />
              <span className="ms-md-3">Coordination failure</span>
            </p>
            <p className="course-list">
              <span className="fa-solid fa-file-invoice-dollar" />
              <span className="ms-md-3">Hidden costs</span>
            </p>

          </div>
        </Col>
        <Col md={6}>
          <div className="course-card right">
            <div className="course-badge">
              <span className="fa-solid fa-check" />
            </div>
            <h2 className="course-card-title  font-weight-bold">We eliminated all of this at SDS</h2>
            <p className="course-list">
              <span className="fa-solid  fa-check" />
              <span className="ms-md-3">Architecture</span>
            </p>
            <p className="course-list">
              <span className="fa-solid  fa-check" />
              <span className="ms-md-3">Interiors</span>
            </p>
            <p className="course-list">
              <span className="fa-solid  fa-check" />
              <span className="ms-md-3">Construction & Approvals</span>
            </p>
            <p className="course-list">
              <span className="fa-solid  fa-check" />
              <span className="ms-md-3">Structural & MEP</span>
            </p>
            <p className="course-list">
              <span className="fa-solid  fa-check" />
              <span className="ms-md-3">Quantity Estimate & Valuation</span>
            </p>
            <p className="course-list">
              <span className="fa-solid  fa-check" />
              <span className="ms-md-3">3D VR/AR</span>
            </p>
            <p className="course-list">
              <span className="fa-solid  fa-check" />
              <span className="ms-md-3">3D Laser Scanning</span>
            </p>

          </div>
        </Col>
      </Row>
    </Container>


  )
}

export default OurServices;